import { render, staticRenderFns } from "./serviciosCli.vue?vue&type=template&id=badd574c&scoped=true"
import script from "./serviciosCli.vue?vue&type=script&lang=js"
export * from "./serviciosCli.vue?vue&type=script&lang=js"
import style0 from "./serviciosCli.vue?vue&type=style&index=0&id=badd574c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badd574c",
  null
  
)

export default component.exports